define("shared/helpers/profile-color-class", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.profileColorClass = profileColorClass;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f

  function profileColorClass(_ref
  /*, hash*/
  ) {
    let [colorClass] = _ref;
    return 'cCA--user__swatch__' + colorClass;
  }

  var _default = (0, _helper.helper)(profileColorClass);

  _exports.default = _default;
});